export function createMessage(type, payload) {
    return {
        type,
        payload,
    };
}
//# sourceMappingURL=createMessage.js.map